export default __webpack_public_path__ + "static/media/booking.889ae964.png";